import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-memberManage",
  "use": "icon-memberManage-usage",
  "viewBox": "0 0 1210 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1210 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-memberManage\"><path d=\"M605.090909 1024L0 418.909091l279.272727-418.909091h651.636364l279.272727 418.909091z m252.741818-665.134545l-263.307636 263.354181L331.217455 358.865455 265.309091 424.727273l329.122909 329.122909 329.122909-329.122909z\" fill=\"#ffffff\" p-id=\"5419\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/memberManage.svg
// module id = Qon8
// module chunks = 32